import moment from 'moment';
const numberOfWorkingDaysFromDate = (startDate, numberOfDays, workingDays)=>{
    return [
        ...Array(numberOfDays)
    ].reduce((noOfDays, _, index)=>{
        const dayName = moment(startDate).add(index, 'day').locale('en').format('dddd');
        return workingDays[dayName] ? noOfDays + 1 : noOfDays;
    }, 0);
};
export const numberOfWorkingDaysBetweenDates = (startDate, endDate, workingDays, includeSaturday = false, includeSunday = false)=>{
    if (endDate.isBefore(startDate)) {
        return 0;
    }
    const totalNoOfDays = endDate.diff(startDate, 'day') + 1;
    let noOfWorkingDays = 0;
    const noOfWorkingDaysInFirstWeek = numberOfWorkingDaysFromDate(startDate, 7, workingDays);
    noOfWorkingDays = noOfWorkingDaysInFirstWeek * Math.floor(totalNoOfDays / 7);
    const remainingDays = totalNoOfDays % 7;
    noOfWorkingDays += numberOfWorkingDaysFromDate(endDate.subtract(remainingDays - 1, 'day'), remainingDays, workingDays);
    if (includeSaturday || includeSunday) {
        const startMoment = moment(startDate);
        const endMoment = moment(endDate);
        let additionalDays = 0;
        const totalCalendarDays = endMoment.diff(startMoment, 'day') + 1;
        for(let i = 0; i < totalCalendarDays; i += 1){
            const currentDate = startMoment.clone().add(i, 'day');
            const dayOfWeek = currentDate.day();
            if (dayOfWeek === 6 && includeSaturday) {
                if (!workingDays.Saturday) {
                    additionalDays += 1;
                }
            } else if (dayOfWeek === 0 && includeSunday) {
                if (!workingDays.Sunday) {
                    additionalDays += 1;
                }
            }
        }
        noOfWorkingDays += additionalDays;
    }
    return noOfWorkingDays;
};
export const isNonWorkingDay = (date, workingDays)=>!workingDays[date.locale('en').format('dddd')];
export const getDateAfterSomeNumberOfWorkingDays = (startDate, numberOfDays, workingDays)=>{
    let daysLeft = numberOfDays;
    let currentDate = startDate.clone();
    while(daysLeft > 0){
        currentDate = currentDate.add(1, 'day');
        if (!isNonWorkingDay(currentDate, workingDays)) {
            daysLeft -= 1;
        }
    }
    return currentDate;
};
export const getEndDateForWorkingDays = (startDate, targetWorkingDays, workingDays, includeSaturday = false, includeSunday = false)=>{
    if (targetWorkingDays <= 0) {
        return startDate.clone();
    }
    const effective = {
        ...workingDays,
        Saturday: Boolean(workingDays.Saturday) || includeSaturday,
        Sunday: Boolean(workingDays.Sunday) || includeSunday
    };
    if (Object.values(effective).every((isWorking)=>!isWorking)) {
        return startDate.clone();
    }
    let workingCount = 0;
    let currentDate = startDate.clone();
    while(true){
        if (!isNonWorkingDay(currentDate, effective)) {
            workingCount += 1;
            if (workingCount === targetWorkingDays) {
                return currentDate;
            }
        }
        currentDate = currentDate.add(1, 'day');
    }
};
